export default __webpack_public_path__ + "static/media/overlay_stars.21a32cc9.svg";